import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useAuthState } from "../../../../../../../Helper/Context";

const ReceivedComplaintAcknowledgePopUp = (props) => {

    const { SingleRawID, handleAcknowledge, confirmBtnCallBack, deleteRecord, message, heading, handleIsPost } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails


    const { t } = useTranslation()

    const [Remark, setRemark] = useState('')
    const [loader, setloader] = useState(false)

    const handleAckData = () => {
        setloader(true)
        const data = {

            T_ComplaintDetails_Data: SingleRawID,
            M_ZoneID: 0,
            M_WardID: 0,
            Officer_M_UserID: 0,
            Remark: Remark,
            M_UserID: UserID,
            Flag: 'ACK',
            token: token,
            handleIsPost,
            setloader:  setloader
        }
        // dispatch(AcknowledgeForwardPostAPI({ data }))
    }

    // const { isloading } = useSelector(state => state.AcknowledgeForwardPostData)


    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">

                                {t('EncroachmentDashboard.Acknowledge')}
                                {/* Forward */}
                            </h5>
                            <button onClick={() => handleAcknowledge()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="row " >


                                    <div class="col-12 col-lg-6 pt-3">

                                        <label for="fname" className=" pb-2">{t('EncroachmentDashboard.Remark')}</label><br />
                                        <input
                                            className="form-control"
                                            id="Remark"
                                            type="text"
                                            name="Remark"
                                            value={Remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 pt-3">
                                        <button
                                            type='button'
                                            onClick={() => handleAckData()}
                                            className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            {/* <i class="fa-solid fa-floppy-disk pe-1"></i> */}
                                            {/* Forward */}
                                            {/* {t('EncroachmentDashboard.Forward')} */}
                                            Acknowledge
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleAcknowledge}
                                            className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default ReceivedComplaintAcknowledgePopUp;